/* LDP · Video flotante en ficha de producto (sections/ldp-video-flotante.liquid)
   Medición: los eventos ldp_video_* y ldp_pdp_heartbeat los recoge el pixel de LDP (Eventos de clientes) y los
   manda al Hub (módulo «Video en Ficha»). Código versionado en gestion-ldp: tema/video-flotante/. */
(function () {
// Cola: si el sistema de píxeles de Shopify todavía no cargó, los eventos esperan (hasta 15 s) en vez de perderse.
var __q = [];
function publish(name, data) {
  __q.push([name, data]);
  flushQueue();
}
function flushQueue() {
  var ready = window.Shopify && Shopify.analytics && Shopify.analytics.publish;
  if (ready) {
    while (__q.length) { var e = __q.shift(); try { Shopify.analytics.publish(e[0], e[1]); } catch (_) {} }
    return;
  }
  if (flushQueue.t) return;
  var tries = 0;
  flushQueue.t = setInterval(function () {
    tries++;
    if ((window.Shopify && Shopify.analytics && Shopify.analytics.publish) || tries > 60) {
      clearInterval(flushQueue.t); flushQueue.t = null; flushQueue();
    }
  }, 250);
}

function init() {
  var wraps = document.querySelectorAll('.ldp-vf-wrap');
  var wrap = wraps[wraps.length - 1];
  if (!wrap) return;
  var root = wrap.querySelector('.ldp-vf');
  var modal = wrap.querySelector('.ldp-vfm');
  if (!root || !modal) return;

  // Al recargar la sección en el editor, quitar copias previas y mover al <body> (evita contextos de apilamiento del tema)
  document.querySelectorAll('body > .ldp-vf, body > .ldp-vfm').forEach(function (el) { el.remove(); });
  document.body.appendChild(root);
  document.body.appendChild(modal);

  var pid = root.dataset.pid, handle = root.dataset.handle;
  var mini = root.querySelector('video');
  var miniBtn = root.querySelector('.ldp-vf__mini');
  var big = modal.querySelector('.ldp-vfm__video');
  var stage = modal.querySelector('.ldp-vfm__stage');
  var bg = modal.querySelector('.ldp-vfm__bg');
  var bar = modal.querySelector('.ldp-vfm__bar span');
  var muteBtn = modal.querySelector('[data-vf-mute]');
  var closeBtn = modal.querySelector('[data-vf-close]');
  var cta = modal.querySelector('[data-vf-cta]');

  function getStore(t) { try { var s = window[t]; s.setItem('__ldp', '1'); s.removeItem('__ldp'); return s; } catch (e) { return null; } }
  var ss = getStore('sessionStorage'), ls = getStore('localStorage');

  // ---------- Configuración y variante ----------
  // La manda el Hub al metacampo de la tienda ldp.video_flotante: { exp, brazos: [{ k, pct, mostrar, forma, tam_m, tam_d,
  // alto_m, alto_d, lado, autoplay, delay, cta }] }. tam_* = % del ancho de la pantalla; alto_* = % del alto desde abajo.
  // Sin metacampo, se arma con los ajustes de la sección (en px, como antes).
  var cfg = null;
  try { var cfgEl = wrap.querySelector('script[data-ldp-vf-cfg]'); if (cfgEl) cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
  if (!cfg || !cfg.brazos || !cfg.brazos.length) {
    var ds = root.dataset;
    var deSeccion = {
      mostrar: true, forma: 'vertical', lado: ds.side || 'left', delay: parseInt(ds.delay || '1500', 10) / 1000,
      autoplay: true, cta: ds.cta !== 'false'
    };
    var h = parseInt(ds.holdout || '0', 10);
    cfg = { exp: ds.exp || '', brazos: h > 0
      ? [Object.assign({}, deSeccion, { k: 'control', pct: h, mostrar: false }), Object.assign({}, deSeccion, { k: 'video', pct: 100 - h })]
      : [Object.assign({}, deSeccion, { k: 'video', pct: 100 })] };
  }
  // Un número al azar por navegador, guardado. Cada experimento lo «baraja» con su ID: la misma persona queda en la
  // misma variante todo el experimento, pero no arrastra su variante de un experimento al siguiente.
  function hashUnit(s) { var x = 2166136261; for (var i = 0; i < s.length; i++) { x ^= s.charCodeAt(i); x = Math.imul(x, 16777619); } return (x >>> 0) / 4294967296; }
  var u = ls ? parseFloat(ls.getItem('ldp_vf_u')) : NaN;
  if (!(u >= 0 && u < 1)) { u = Math.random(); if (ls) ls.setItem('ldp_vf_u', String(u)); }
  var pos = cfg.exp ? (u + hashUnit(cfg.exp)) % 1 : u;
  var arm = cfg.brazos[cfg.brazos.length - 1], acum = 0;
  for (var ai = 0; ai < cfg.brazos.length; ai++) { acum += (cfg.brazos[ai].pct || 0) / 100; if (pos < acum) { arm = cfg.brazos[ai]; break; } }
  var group = String(arm.k || 'video');
  var mostrar = arm.mostrar !== false;
  root.dataset.side = arm.lado === 'right' ? 'right' : 'left';
  root.dataset.forma = arm.forma || 'vertical';
  // El CSS pone mínimo y máximo en px (clamp) para que no quede diminuto ni gigante.
  if (arm.tam_m) root.style.setProperty('--vf-w-m', arm.tam_m + 'vw');
  if (arm.tam_d) root.style.setProperty('--vf-w-d', arm.tam_d + 'vw');
  if (arm.alto_m != null) root.style.setProperty('--vf-b-m', arm.alto_m + 'vh');
  if (arm.alto_d != null) root.style.setProperty('--vf-b-d', arm.alto_d + 'vh');
  modal.classList.toggle('no-cta', arm.cta === false);
  var segs = function (b) { return Math.round((b && b.delay != null ? b.delay : 1.5) * 1000); };
  var delayMs = segs(arm);
  // La impresión se cuenta en el MISMO momento en todas las variantes (el más tardío): si una variante aparece al tiro y
  // otra a los 3 s, contar a cada una en su segundo dejaría fuera de la segunda a los que se van antes, y la
  // comparación de conversión quedaría a favor de la tardía.
  var impMs = 0;
  for (var bi = 0; bi < cfg.brazos.length; bi++) impMs = Math.max(impMs, segs(cfg.brazos[bi]));

  // Tráfico interno: abrir la tienda una vez con ?ldp_internal=1 marca el navegador (con =0 se desmarca).
  try {
    var qi = new URLSearchParams(location.search).get('ldp_internal');
    if (ls && qi === '1') ls.setItem('ldp_internal', '1');
    if (ls && qi === '0') ls.removeItem('ldp_internal');
  } catch (e) {}
  var internal = !!(ls && ls.getItem('ldp_internal') === '1');
  var viewId = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  var base = {
    product_id: pid, product_handle: handle, group: group,
    video_id: root.dataset.videoId || null,
    video_version: root.dataset.version || 'A',
    experiment_id: cfg.exp || '',
    view_id: viewId,
    theme_role: (window.Shopify && Shopify.theme && Shopify.theme.role) || null, // solo 'main' se analiza
    internal: internal
  };

  function track(action, extra) {
    var d = {};
    for (var k in base) d[k] = base[k];
    if (extra) for (var j in extra) d[j] = extra[j];
    publish('ldp_video_' + action, d);
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'ldp_video_' + action }, d)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('ldp:video', { detail: Object.assign({ action: action }, d) })); } catch (e) {}
  }

  track('eligible');

  // Tiempo activo en la ficha (pestaña visible), en AMBOS grupos: por eso va antes del return del control.
  if (window.__ldpVfHeartbeat) clearInterval(window.__ldpVfHeartbeat);
  var active = 0;
  window.__ldpVfHeartbeat = setInterval(function () {
    if (document.hidden || active >= 600) return; // tope 10 min
    active += 15;
    publish('ldp_pdp_heartbeat', { product_id: pid, view_id: viewId, group: group, experiment_id: base.experiment_id,
      theme_role: base.theme_role, internal: internal, active_seconds: active });
  }, 15000);

  // Impresión = la persona seguía en la ficha cuando el video aparece (o aparecería). Se registra en TODAS las
  // variantes, también en la que no muestra video: así «de los que lo vieron, cuántos agregaron al carro» se puede
  // comparar entre con y sin video.
  var dismissed = !!(ss && ss.getItem('ldp_vf_dismiss_' + pid));
  function schedule() {
    setTimeout(function () { if (mostrar && !dismissed) show(); }, delayMs);
    setTimeout(function () { track('impression'); }, impMs);
  }
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule, { once: true });
  if (!mostrar) return;

  var quiet = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
              (navigator.connection && navigator.connection.saveData) || arm.autoplay === false;
  var isOpen = false, openedAt = 0, prevOverflow = ['', ''], fired = {};

  function playMini() {
    if (quiet) { root.classList.add('is-static'); return; }
    if (!mini.getAttribute('src')) mini.src = root.dataset.sd;
    mini.muted = true;
    var p = mini.play();
    if (p && p.catch) p.catch(function () { root.classList.add('is-static'); });
  }
  mini.addEventListener('playing', function () { root.classList.add('is-playing'); root.classList.remove('is-static'); });

  function show() {
    root.hidden = false;
    playMini();
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
    // «Lo dejó activo más de 5 s»: 5 segundos con la miniatura (o el video ampliado) a la vista y la pestaña visible.
    var visto = 0;
    var t5 = setInterval(function () {
      if (!root.classList.contains('is-in') && !isOpen) { if (root.hidden) clearInterval(t5); return; }
      if (document.hidden) return;
      if (++visto >= 5) { clearInterval(t5); track('visto5'); }
    }, 1000);
  }

  // ---------- Vista ampliada ----------
  function setMuted(m) {
    big.muted = m;
    modal.classList.toggle('is-muted', m);
    muteBtn.setAttribute('aria-label', m ? 'Activar sonido' : 'Silenciar');
  }
  function lockScroll(on) {
    var h = document.documentElement, bd = document.body;
    if (on) { prevOverflow = [h.style.overflow, bd.style.overflow]; h.style.overflow = 'hidden'; bd.style.overflow = 'hidden'; }
    else { h.style.overflow = prevOverflow[0]; bd.style.overflow = prevOverflow[1]; }
  }
  function tick() {
    if (!isOpen) return;
    if (big.duration) bar.style.transform = 'scaleX(' + Math.min(1, big.currentTime / big.duration) + ')';
    requestAnimationFrame(tick);
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    var t = mini.currentTime || 0;
    mini.pause();
    root.style.visibility = 'hidden';
    modal.hidden = false;
    modal.classList.add('is-loading');
    modal.classList.remove('is-paused');
    if (big.getAttribute('src') !== root.dataset.hd) big.src = root.dataset.hd;
    setMuted(!!(ss && ss.getItem('ldp_vf_muted') === '1'));
    // play() dentro del gesto del usuario (requisito de iOS para reproducir con sonido)
    var p = big.play();
    if (p && p.catch) p.catch(function () { setMuted(true); big.play().catch(function () { modal.classList.add('is-paused'); }); });
    var seek = function () { try { if (t > 0.3 && Math.abs(big.currentTime - t) > 0.3) big.currentTime = t; } catch (e) {} };
    if (big.readyState >= 1) seek(); else big.addEventListener('loadedmetadata', seek, { once: true });
    lockScroll(true);
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    try { history.pushState({ ldpVf: 1 }, ''); } catch (e) {}
    openedAt = Date.now();
    fired = {};
    requestAnimationFrame(tick);
    try { closeBtn.focus({ preventScroll: true }); } catch (e) {}
    track('open');
  }

  function close(fromHistory) {
    if (!isOpen) return;
    isOpen = false;
    var t = big.currentTime || 0;
    big.pause();
    modal.classList.remove('is-open');
    setTimeout(function () { modal.hidden = true; stage.style.transform = ''; stage.style.transition = ''; bg.style.opacity = ''; }, 260);
    lockScroll(false);
    root.style.visibility = '';
    if (!fromHistory && history.state && history.state.ldpVf) { try { history.back(); } catch (e) {} }
    if (!quiet && mini.getAttribute('src')) { try { mini.currentTime = t; } catch (e) {} mini.play().catch(function () {}); }
    try { miniBtn.focus({ preventScroll: true }); } catch (e) {}
    track('close', { seconds: Math.round((Date.now() - openedAt) / 1000) });
  }

  function dismiss() {
    mini.pause();
    root.classList.remove('is-in');
    setTimeout(function () { root.hidden = true; mini.removeAttribute('src'); mini.load(); }, 400);
    if (ss) ss.setItem('ldp_vf_dismiss_' + pid, '1');
    track('dismiss');
  }

  function goToBuy() {
    var el = document.querySelector('variant-selects, variant-radios, product-form, form[action*="/cart/add"]');
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  miniBtn.addEventListener('click', open);
  root.querySelector('.ldp-vf__x').addEventListener('click', function (e) { e.stopPropagation(); dismiss(); });
  closeBtn.addEventListener('click', function () { close(false); });
  bg.addEventListener('click', function () { close(false); });
  muteBtn.addEventListener('click', function () {
    setMuted(!big.muted);
    if (ss) ss.setItem('ldp_vf_muted', big.muted ? '1' : '0');
    if (!big.muted && big.paused) big.play().catch(function () {});
    track(big.muted ? 'mute' : 'unmute');
  });
  if (cta) cta.addEventListener('click', function () {
    track('cta');
    close(false);
    setTimeout(goToBuy, 380); // después de que el history.back() restaure la posición
  });
  window.addEventListener('popstate', function () { if (isOpen) close(true); });

  big.addEventListener('waiting', function () { modal.classList.add('is-loading'); });
  big.addEventListener('playing', function () { modal.classList.remove('is-loading', 'is-paused'); });
  big.addEventListener('canplay', function () { modal.classList.remove('is-loading'); });
  big.addEventListener('pause', function () { if (isOpen) modal.classList.add('is-paused'); });

  // Retención en la vista ampliada: 25/50/75/100 % una vez por apertura. Con loop no se dispara `ended`,
  // por eso el 95 % cuenta como completo.
  big.addEventListener('timeupdate', function () {
    if (!isOpen || !big.duration) return;
    var r = (big.currentTime / big.duration) * 100;
    [25, 50, 75, 95].forEach(function (p) {
      if (r >= p && !fired[p]) { fired[p] = true; track('progress', { pct: p === 95 ? 100 : p }); }
    });
  });

  // Tocar el video = pausa/reanuda; deslizar hacia abajo = cerrar
  var y0 = null, dy = 0, moved = false;
  stage.addEventListener('touchstart', function (e) {
    if (e.target.closest('button')) { y0 = null; return; }
    y0 = e.touches[0].clientY; dy = 0; moved = false; stage.style.transition = 'none';
  }, { passive: true });
  stage.addEventListener('touchmove', function (e) {
    if (y0 === null) return;
    dy = e.touches[0].clientY - y0;
    if (Math.abs(dy) > 8) moved = true;
    if (dy > 0) { stage.style.transform = 'translateY(' + dy + 'px)'; bg.style.opacity = String(Math.max(0, 1 - dy / 400)); }
  }, { passive: true });
  stage.addEventListener('touchend', function () {
    if (y0 === null) return;
    stage.style.transition = '';
    if (dy > 110) { close(false); } else { stage.style.transform = ''; bg.style.opacity = ''; }
    y0 = null;
  });
  big.addEventListener('click', function () {
    if (moved) { moved = false; return; }
    if (big.paused) big.play().catch(function () {}); else big.pause();
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(false); return; }
    if (e.key === 'Tab') {
      var f = [].slice.call(modal.querySelectorAll('button'));
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { mini.pause(); big.pause(); }
    else if (isOpen) { big.play().catch(function () {}); }
    else if (root.classList.contains('is-in') && !quiet) { mini.play().catch(function () {}); }
  });

  window.LDPVideoFlotante = { open: open, close: function () { close(false); }, group: group };
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
// Editor de temas: re-inicializar cuando se recarga la sección
document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('.ldp-vf-wrap')) init(); });
})();